const {CardDeck, MilitaryCardTypes}  = require("../../Constants/Constants");
const Card = require("./Card");

class TacticCard extends Card{
    constructor(tactic)
    {
        super(
            CardDeck.Military,
            MilitaryCardTypes.Tactic,
            null,
            tactic.GetName(),
            tactic.GetAge(),
            tactic.GetText(),
            tactic.GetEffects(),
        )
        this.tactic = tactic;
    }
}

module.exports = TacticCard;